import React from "react";
import api from "../../../api/Api";
import Loader from "../../../components/Loader";
import {NavLink} from "react-router-dom";
import ReactTable from "react-table";
import "react-table/react-table.css";

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import {
    mappingUI, dashboardRouter, getDateConverter
} from '../../../util/globalHelper';
import Permissions from '../../../util/globalPermissions';
import Icon from "@material-ui/core/Icon";
import Button from "components/CustomButtons/Button.jsx";

class UserRoleView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            checkedItems: [],
            permissions: null,
            clinicmasterID: null,
            user_id: null,
            eventList: null,
            alert: null,

        };
        this.handleChange = this.handleChange.bind(this);
    }


    handleChange(e) {
        const state = this.state.checkedItems;
        state[e.target.name] = e.target.checked;
        this.setState(state);
    }

    componentDidMount() {
        this.setState({
            clinicmasterID: this.props.match.params.clinicMasterID,
            user_id: this.props.match.params.id
        });
        this.CallReadApi(this.props.match.params.clinicMasterID, this.props.match.params.id)
    }

    render() {
        const {data} = this.state;
        if (this.state.data && this.state.evenList !== null)
            return (<div>
                {this.state.alert}
                <div>
                    <Card>
                        <CardHeader color="info" text>
                            <CardText color="info">
                                <h4>User Role Details</h4>
                            </CardText>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12}>
                                    <h2 style={{margin: 20}}>{data.clinicmaster_name}</h2>
                                </GridItem>
                                <GridItem xs={12} sm={8} md={8}>
                                    <div style={{margin: 20}}>
                                        <br></br>
                                        <h4>
                                            <b>Name:</b>&nbsp;&nbsp; {data.user_id.name}
                                        </h4>
                                        <h4><b>Email:</b>&nbsp;&nbsp;{data.user_id.email}</h4>
                                        <h4><b>Contact:</b>&nbsp;&nbsp;{data.user_id.contact}</h4>

                                        <br/>
                                        <h4><b>Username:&nbsp;&nbsp;</b>{data.user_id.username}</h4>
                                        <br/>
                                        <h4><b>Status:</b>&nbsp;&nbsp;{data.user_id.status}</h4>


                                    </div>
                                </GridItem>
                                {mappingUI(Permissions.UpdateUser) ?
                                    <GridItem xs={12} sm={4} md={2} style={{marginTop: 50}}>
                                        <div>
                                            <NavLink
                                                to={dashboardRouter(`/user/role/update/clinicmaster/${this.state.clinicmasterID}/${this.state.user_id}`)}>
                                                <Button block size="md" color="warning">
                                                    <Icon>border_color</Icon>
                                                    <span style={{paddingLeft: 10}}>Update</span>
                                                </Button>
                                            </NavLink>

                                        </div>
                                        <div>
                                            <Button block size="md" color="gray" onClick={() => {
                                                this.CreateAlert(this.props.match.params.id);
                                            }}>
                                                <Icon>close</Icon>
                                                <span style={{paddingLeft: 10}}>Delete</span>
                                            </Button>
                                        </div>

                                    </GridItem> : null}
                            </GridContainer>
                            {this.state.eventList !== null && this.state.eventList !== undefined ?
                                <GridContainer>
                                    <GridItem xs={12}>
                                        <h4><b>Events</b></h4>
                                        {this.state.eventList ? <ReactTable
                                            data={this.state.eventList}
                                            columns={[
                                                {
                                                    columns: [
                                                        {
                                                            Header: "API",
                                                            accessor: "api",
                                                        },
                                                        {
                                                            Header: "Time",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{this.state.eventList[index] ? new Date(this.state.eventList[index].created_at).toLocaleString() : "No Date"}</p>

                                                                    </div>
                                                                ),
                                                        }
                                                    ]
                                                }
                                            ]}
                                            defaultPageSize={10}
                                            className="-striped -highlight"
                                        /> : null}
                                    </GridItem>
                                </GridContainer> : null}
                        </CardBody>
                    </Card>

                </div>
            </div>)
        if (this.state.data === undefined)
            return (<div><h1 style={{textAlign: 'center'}} className="text-center">No Access</h1></div>)
        else
            return (
                <div>
                    <Loader/>
                </div>
            )
    }

    CallReadApi = (clinicid, id) => {
        var postbody = {
            "clinic_master_id": clinicid,
            "user_id": id
        };
        api.getUsersList(postbody).then(json => {
            this.setState({data: json.data[0]})
        });
        api.getEvents(postbody).then(json => {
            this.setState({eventList: json.data.data})
        });
    };

    Checkbox = (name, checked) => (
        <input type={'checkbox'} name={name} checked={checked} onChange={this.handleChange}/>
    );

    DeleteUser() {
    }


    hideAlert() {
        this.setState({
            alert: null
        });
    }

    successDelete() {
        this.setState({
            alert: null
        });
        this.props.history.push("/roles/user")
    }

    CreateAlert(id) {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{display: "block", marginTop: "-100px"}}
                    title="Are you sure?"
                    onConfirm={() => {
                        this.successDelete();
                        this.deleteRecord(id)
                    }}
                    onCancel={() => this.hideAlert()}
                    confirmBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.success
                    }
                    cancelBtnCssClass={
                        this.props.classes.button + " " + this.props.classes.danger
                    }
                    confirmBtnText="Yes, delete it!"
                    cancelBtnText="Cancel"
                    showCancel
                >
                    You will not be able to recover this user!
                </SweetAlert>
            )
        });
    }

    deleteRecord(id) {
        var postBody = {"user_id": id};
        api.deletePatient(postBody)
            .then(json => {
            });

    }

    // successDelete() {
    //     this.setState({
    //         alert: (
    //             <SweetAlert
    //                 success
    //                 style={{display: "block", marginTop: "-100px"}}
    //                 title="Deleted!"
    //                 onConfirm={() => this.successDelete()}
    //                 onCancel={() => this.hideAlert()}
    //                 confirmBtnCssClass={
    //                     this.props.classes.button + " " + this.props.classes.success
    //                 }
    //             >
    //             </SweetAlert>
    //         )
    //     });
    // }
}

export default withStyles(sweetAlertStyle)(UserRoleView);



// WEBPACK FOOTER //
// ./src/views/Roles/User/UserRoleView.jsx